
import { INavigationLink } from '@/types/foerderApp'
import { IPhoto } from '@/types/photos'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import IndividualColorMixin from '../mixins/IndividualColorMixin.vue'

@Component
export default class LinkContainer extends Mixins(IndividualColorMixin) {
  @Prop() links!: INavigationLink[]
  @Prop() documents!: IPhoto[]
}
